import React, { useEffect, useState } from 'react';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import { NavLink } from 'react-router-dom';
import Header from '../../Components/Header';
import Footer from '../../Components/Footer';
import Preloader from '../../Components/Preloader';
import AboutSeo from '../../SEO/AboutSeo';

function DownloadApp() {
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        setTimeout(() => {
            setIsLoading(false);
        }, 500);

        const handleScroll = () => {
            const scroll = window.scrollY;
            const stickyHeader = document.getElementById('sticky-header');
            const scrollToTarget = document.querySelector('.scroll-to-target');

            if (scroll < 245) {
                stickyHeader?.classList.remove('sticky-menu');
                scrollToTarget?.classList.remove('open');
            } else {
                stickyHeader?.classList.add('sticky-menu');
                scrollToTarget?.classList.add('open');
            }
        };

        window.addEventListener('scroll', handleScroll);

        const thmSwiperInit = () => {
            console.log('Swiper initialized');
        };

        thmSwiperInit();

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);


    return (
        <div>
            {isLoading ? (
                <Preloader />
            ) : (
                <div>
                    <AboutSeo />

                    {/* back to top */}
                    <button
                        className="scroll-top scroll-to-target"
                        data-target="html"
                        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                    >
                        <i className="fa-solid fa-angles-up" />
                    </button>

                    <div>
                        <Header />

                        {/* Breadcumb Section */}
                        <section
                            id="site-breadcumb"
                            style={{
                                backgroundImage:
                                    'url("assets/images/breadcumb/breadcumb-bd.svg")',
                            }}
                        >
                            <div className="site-breadcumb-wrapper">
                                <div className="container">
                                    <div className="row">
                                        <div className="col">
                                            <div className="breadcumb-content">
                                                <h1 className="breadcumb-title">
                                                    Download PayQuick App
                                                </h1>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>

                        {/* ⭐ ADDED SECTION START ⭐ */}
                        <section style={styles.section}>
                            <div className="container">
                                <div className="row align-items-center">

                                    {/* LEFT CONTENT */}
                                    <div className="col-lg-5 mb-5 mb-lg-0">
                                        <span style={styles.badge}>AVAILABLE NOW</span>

                                        <h3 style={styles.mainTitle}>
                                            Send Money Globally <br /> With Confidence
                                        </h3>

                                        <p style={styles.description}>
                                           PayQuick delivers fast, secure, and low-cost international money transfers using modern technology.
Scan the QR code to download the app and send money globally with real-time tracking and 24/7 support.
                                        </p>

                                        <div className="row mt-4">
                                            <div className="col-6 d-flex justify-content-center">
                                                <div style={styles.qrCard}>
                                                    <a
                                                        href="https://play.google.com/store/apps/details?id=com.org.payquick "
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        style={styles.link}
                                                    >
                                                        <img
                                                            src="../assets/images/QR/PayquickPLAY.jpg"
                                                            alt="Google Play QR"
                                                            style={styles.qrImage}
                                                        />
                                                        <p style={styles.storeText}>Google Play</p>
                                                    </a>
                                                </div>
                                            </div>

                                            <div className="col-6 d-flex justify-content-center">
                                                <div style={styles.qrCard}>
                                                    <a
                                                        href="https://apps.apple.com/us/app/payquik-uk/id6737229185"
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        style={styles.link}
                                                    >
                                                        <img
                                                            src="../assets/images/QR/PayquickAPP.jpg"
                                                            alt="App Store QR"
                                                            style={styles.qrImage}
                                                        />
                                                        <p style={styles.storeText}>App Store</p>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* RIGHT CONTENT – MOBILE IMAGE */}
                                    <div className="col-lg-7 text-center">
                                        <div style={styles.phoneWrapper}>
                                            <img
                                                src="../assets/images/about/about04.png"
                                                alt="App UI"
                                                className="img-fluid"
                                                style={styles.mobileImage}
                                            />
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </section>
                        {/* ⭐ ADDED SECTION END ⭐ */}

                        <Footer />
                    </div>
                </div>
            )}
        </div>
    );
}

export default DownloadApp;



/* ------------------  STYLES BLOCK ------------------ */

const styles = {
  section: {
    padding: "80px 15px",
    background: "radial-gradient(circle at top right, #e8fff0, #f0f7ff 60%)",
  },

  badge: {
    display: "inline-block",
    padding: "6px 14px",
    background: "#29a82a",      // GREEN
    color: "#ffffff",
    fontSize: "12px",
    fontWeight: "600",
    borderRadius: "20px",
    marginBottom: "18px",
  },

  mainTitle: {
    fontSize: "34px",
    fontWeight: "700",
    lineHeight: "1.3",
    color: "#164343",           // DEEP TEAL
    marginBottom: "15px",
  },

  description: {
    fontSize: "16px",
    color: "#164343",           // DEEP TEAL (subtle)
    maxWidth: "420px",
  },

  qrCard: {
    width: "220px",
    borderRadius: "22px",
    padding: "24px",
    background: "#fff",
    border: "2px solid transparent",
    backgroundImage: `
      linear-gradient(#ffffff, #ffffff),
      linear-gradient(135deg, #3498db, #29a82a, #3498db)
    `,                          // BLUE → GREEN → BLUE
    backgroundOrigin: "border-box",
    backgroundClip: "padding-box, border-box",
    boxShadow: "0 18px 35px rgba(52,152,219,0.25)", // BLUE SHADOW
    textAlign: "center",
    transition: "all .3s ease",
  },

  qrImage: {
    width: "150px",
    height: "150px",
    objectFit: "contain",
    marginBottom: "10px",
  },

  storeText: {
    fontSize: "14px",
    fontWeight: "600",
    color: "#164343",           // DEEP TEAL
    margin: 0,
  },

  link: { textDecoration: "none", color: "inherit" },

  phoneWrapper: { position: "relative", display: "inline-block" },

  mobileImage: {
    maxWidth: "520px",
    width: "100%",
    filter: "drop-shadow(0 40px 70px rgba(52,152,219,0.35))", // BLUE SHADOW
  },
};
